import MainApiService from "../../services/mainApi.service";

const contractTypeServiceURL =
  process.env.REACT_APP_MAIN + "/api/v1/SalesContractType/";

export const salesContractTypeService = new MainApiService(
  contractTypeServiceURL
);
